import _extends from "@babel/runtime/helpers/extends";
import * as React from "react";
import { forwardRef } from "react";
const SvgComponent = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "none",
  viewBox: "0 0 20 20",
  ref: ref
}, props), /*#__PURE__*/React.createElement("path", {
  fill: "var(--smar--ursa-icons--backgroundColor, transparent)",
  d: "M17.3 11.123H8.18V8.907h9.12v2.216Z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M7.48 8.907a.7.7 0 0 1 .7-.7h9.12a.7.7 0 0 1 .7.7v2.216a.7.7 0 0 1-.7.7H8.18a.7.7 0 0 1-.7-.7V8.907Zm1.4.7v.816h7.72v-.816H8.88Zm-2.957-.998a.7.7 0 0 1 .002.99l-1.692 1.698a.7.7 0 0 1-.992 0l-1.037-1.04a.7.7 0 0 1 .992-.989l.541.543 1.196-1.2a.7.7 0 0 1 .99-.002Z",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  fill: "var(--smar--ursa-icons--backgroundColor, transparent)",
  d: "M17.3 15.641H8.18v-2.215h9.12v2.215Z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M7.48 13.426a.7.7 0 0 1 .7-.7h9.12a.7.7 0 0 1 .7.7v2.215a.7.7 0 0 1-.7.7H8.18a.7.7 0 0 1-.7-.7v-2.215Zm1.4.7v.815h7.72v-.815H8.88Zm-2.957-.998a.7.7 0 0 1 .002.99l-1.692 1.698a.7.7 0 0 1-.992 0l-1.037-1.04a.7.7 0 1 1 .992-.989l.541.543 1.196-1.2a.7.7 0 0 1 .99-.002Z",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  fill: "var(--smar--ursa-icons--backgroundColor, transparent)",
  d: "M17.3 6.574H8.18V4.36h9.12v2.215Z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M7.48 4.359a.7.7 0 0 1 .7-.7h9.12a.7.7 0 0 1 .7.7v2.215a.7.7 0 0 1-.7.7H8.18a.7.7 0 0 1-.7-.7V4.36Zm1.4.7v.815h7.72V5.06H8.88ZM5.924 4.06a.7.7 0 0 1 .002.99L4.233 6.749a.7.7 0 0 1-.992 0l-1.037-1.04a.7.7 0 0 1 .992-.989l.541.543 1.196-1.2a.7.7 0 0 1 .99-.002Z",
  clipRule: "evenodd"
}));
const ForwardRef = /*#__PURE__*/forwardRef(SvgComponent);
export default ForwardRef;
//# sourceMappingURL=TaskListIcon20.js.map